import React, { useEffect, useRef } from "react";
import CheckboxAnswerCDMQB from "./AnswerComponents/CheckboxAnswer/Checkboxanswercdmqb";
import InputAnswerCDMQB from "./AnswerComponents/InputAnswer/Inputanswercdmqb";
import "./Simulationbodycdmqb.css";

export default function SimulationBodyCDMQB(props) {
  // Split layout (case on the left, current question + answers on the
  // right) is on
  // unless turned off with the "Split screen" setting (props.splitLayout).
  // Whether it actually splits also depends on screen width: the grid only
  // kicks in inside the CSS media query, so on smaller screens the panes
  // simply stack like the original layout.
  const splitLayout = props.splitLayout !== false;

  // In split mode the answer pane scrolls on its own.
  const answerPaneRef = useRef(null);

  // New part: start the answer pane back at the top.
  useEffect(() => {
    if (answerPaneRef.current) {
      answerPaneRef.current.scrollTop = 0;
    }
  }, [props.currentQuestion]);

  const getPreviousQuestions = () => {
    let questionsArray = [];
    for (let i = 1; i < props.currentQuestion; ++i) {
      questionsArray.push(
        <div key={i}>
          <p
            className="simulationBodyPrevQuestionsTitleCDMQB"
            data-id={`prev_question_title_${i}`}
          >
            <span data-id="container-break">
              {props.getHighlightedText
                ? props.getHighlightedText(
                    `Question ${i}`,
                    `prev_question_title_${i}`,
                  )
                : `Question ${i}`}
            </span>
          </p>
          <p
            className="simulationBodyPrevQuestionsTextCDMQB"
            data-id={`prev_question_text_${i}`}
          >
            <span data-id="container-break">
              {props.getHighlightedText
                ? props.getHighlightedText(
                    props.simulationData.qo[i - 1].QUESTION,
                    `prev_question_text_${i}`,
                  )
                : props.simulationData.qo[i - 1].QUESTION}
            </span>
          </p>
          {i + 1 < props.currentQuestion && <br />}
          {props.simulationData.qo[i - 1].ADDITIONALINFO !== "" && (
            <div>
              <p
                className="simulationBodyPrevQuestionsTextCDMQB"
                data-id={`prev_question_additional_${i}`}
              >
                <span data-id="container-break">
                  {props.getHighlightedText
                    ? props.getHighlightedText(
                        props.simulationData.qo[i - 1].ADDITIONALINFO,
                        `prev_question_additional_${i}`,
                      )
                    : props.simulationData.qo[i - 1].ADDITIONALINFO}
                </span>
              </p>
              {i + 1 < props.currentQuestion && <br />}
            </div>
          )}
        </div>,
      );
    }
    return questionsArray;
  };

  return (
    <div
      className={`simulationBodyContainerCDMQB${
        splitLayout ? " simulationBodySplitCDMQB" : ""
      }`}
    >
      {/* ---------------- Left pane: case + previous questions ---------------- */}
      <div className="simulationBodyQuestionPaneCDMQB">
        {props.settings.originalLabInstruction && (
          <div className="simulationInsLabBodyOriginalPlacement">
            <button
              type="button"
              className="simulationOriginalCDMQBCaseButton"
              onClick={props.displayLabPanels}
              title="Lab Panels"
            >
              <img
                className="simulationHeaderInstructionsIconCDMQB"
                src="/exhibit.png"
                alt=""
                draggable={false}
              />
              LAB PANELS
            </button>
            <button
              className="simulationOriginalCDMQBCaseButton"
              onClick={props.displayInstructions}
              title="Instructions"
            >
              <img
                className="simulationHeaderInstructionsIconCDMQB"
                src="/exhibit.png"
                alt=""
                draggable={false}
              />
              INSTRUCTIONS
            </button>
          </div>
        )}
        <h3
          className="simulationBodyHeaderCDMQB highlightedHeaderCDMQB"
          data-id="case_header"
        >
          <span data-id="container-break">
            {props.getHighlightedText
              ? props.getHighlightedText(
                  `Case ${props.caseNumber}, Part ${props.currentQuestion} of ${props.simulationData.qo.length}`,
                  "case_header",
                )
              : `Case ${props.caseNumber}, Part ${props.currentQuestion} of ${props.simulationData.qo.length}`}
          </span>
        </h3>

        <p className="simulationBodyTextCDMQB" data-id="case_presentation">
          <span data-id="container-break">
            {props.getHighlightedText
              ? props.getHighlightedText(
                  props.simulationData.CASEPRESENTATION,
                  "case_presentation",
                )
              : props.simulationData.CASEPRESENTATION}
          </span>
        </p>

        <table className="simulationBodyTableCDMQB">
          <tbody>
            {props.simulationData.INITIALINFO.map((value, index) => (
              <tr
                className="simulationBodyTableRowCDMQB"
                key={`bodyRow${index}`}
              >
                <td
                  className="simulationBodyTableColumnCDMQB"
                  data-id={`vital_${index}`}
                >
                  <span data-id="container-break">
                    {props.getHighlightedText
                      ? props.getHighlightedText(value.vital, `vital_${index}`)
                      : value.vital}
                  </span>
                </td>
                <td
                  className="simulationBodyTableColumnCDMQB"
                  data-id={`vital_value_${index}`}
                >
                  <span data-id="container-break">
                    {props.getHighlightedText
                      ? props.getHighlightedText(
                          value.value,
                          `vital_value_${index}`,
                        )
                      : value.value}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {props.simulationData.qo[0].ADDITIONALINFO !== "" && (
          <p
            className="simulationBodyTextCDMQB"
            data-id="initial_additional_info"
          >
            <span data-id="container-break">
              {props.getHighlightedText
                ? props.getHighlightedText(
                    props.simulationData.qo[0].ADDITIONALINFO,
                    "initial_additional_info",
                  )
                : props.simulationData.qo[0].ADDITIONALINFO}
            </span>
          </p>
        )}

        {props.currentQuestion > 1 && (
          <div
            className="simulationBodyPrevQuestionsContainerCDMQB"
            style={{
              marginTop:
                props.simulationData.qo[0].ADDITIONALINFO === "" ? 20 : 0,
            }}
          >
            <p
              className="simulationBodyPrevQuestionsTextCDMQB"
              data-id="prev_questions_header"
            >
              <span data-id="container-break">
                {props.getHighlightedText
                  ? props.getHighlightedText(
                      "PREVIOUS QUESTIONS RELATED TO THIS CASE:",
                      "prev_questions_header",
                    )
                  : "PREVIOUS QUESTIONS RELATED TO THIS CASE:"}
              </span>
            </p>
            {getPreviousQuestions().map((value) => value)}
          </div>
        )}
      </div>

      {/* ---------------- Right pane: current question + answers ---------------- */}
      {/* In split mode the pane fills the body height (it carries the
          divider) and scrolls on its own if the content is long. */}
      <div className="simulationBodyAnswerPaneCDMQB" ref={answerPaneRef}>
        <h3
          id="beginQuestionElement"
          className="simulationBodyHeaderCDMQB highlightedHeaderCDMQB"
          data-id="current_part_header"
        >
          <span data-id="container-break">
            {props.getHighlightedText
              ? props.getHighlightedText(
                  `Part ${props.currentQuestion} of ${props.simulationData.qo.length}`,
                  "current_part_header",
                )
              : `Part ${props.currentQuestion} of ${props.simulationData.qo.length}`}
          </span>
        </h3>

        {props.simulationData.qo[props.currentQuestion - 1].ADDITIONALINFO !==
          "" && (
          <p
            className="simulationBodyTextCDMQB"
            data-id="current_additional_info"
          >
            <span data-id="container-break">
              {props.getHighlightedText
                ? props.getHighlightedText(
                    props.simulationData.qo[props.currentQuestion - 1]
                      .ADDITIONALINFO,
                    "current_additional_info",
                  )
                : props.simulationData.qo[props.currentQuestion - 1]
                    .ADDITIONALINFO}
            </span>
          </p>
        )}

        {props.simulationData.qo[props.currentQuestion - 1].ADDITIONALIMAGE !==
          "" && (
          <img
            className="simulationBodyImageCDMQB"
            src={
              "https://app.cdmcases.com/" +
              props.simulationData.qo[props.currentQuestion - 1].ADDITIONALIMAGE
            }
            alt="Additional content"
          />
        )}

        <div className="simulationBodyHeaderWrapperCDMQB">
          <h3
            className="simulationBodyHeaderCDMQB"
            style={{ margin: "0px" }}
            data-id="current_question_header"
          >
            <span data-id="container-break">
              {props.getHighlightedText
                ? props.getHighlightedText(
                    `Question ${props.currentQuestion}`,
                    "current_question_header",
                  )
                : `Question ${props.currentQuestion}`}
            </span>
          </h3>
          {props.simulationData.qo[props.currentQuestion - 1].BLANKTYPE && (
            <svg
              onClick={props.showHelpPopup}
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="info-circle"
              style={{
                width: "20px",
                alignSelf: "center",
                marginLeft: "10px",
                cursor: "pointer",
              }}
              className="svg-inline--fa fa-info-circle fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                className="simulationBodyInfoIconCDMQB"
                d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
              ></path>
            </svg>
          )}
        </div>

        {/* Current question text */}
        <p className="simulationBodyTextCDMQB" data-id="current_question_text">
          <span data-id="container-break">
            {props.getHighlightedText(
              props.simulationData.qo[props.currentQuestion - 1].QUESTION,
              "current_question_text",
            )}
          </span>
        </p>

        {props.simulationData.qo[props.currentQuestion - 1].BLANKTYPE ? (
          <InputAnswerCDMQB
            modifyInputAnswer={props.modifyInputAnswer}
            simulationData={props.simulationData}
            answerList={props.answerList}
            currentQuestion={props.currentQuestion}
            getHighlightedText={props.getHighlightedText}
          />
        ) : (
          <CheckboxAnswerCDMQB
            updateCheckboxAnswer={props.updateCheckboxAnswer}
            selectedCheckboxAmount={props.selectedCheckboxAmount}
            simulationData={props.simulationData}
            currentQuestion={props.currentQuestion}
            answerList={props.answerList}
            getHighlightedText={props.getHighlightedText}
          />
        )}
      </div>
    </div>
  );
}